exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".detail-container[data-v-7ad206ea]{padding:10px}.detail-item[data-v-7ad206ea]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:start;-ms-flex-align:start;align-items:flex-start;margin-bottom:10px}.detail-label[data-v-7ad206ea]{width:100px;-ms-flex-negative:0;flex-shrink:0;color:#86e0ff;font-weight:500}.detail-value[data-v-7ad206ea]{-webkit-box-flex:1;-ms-flex:1;flex:1;word-break:break-all}", ""]);

// exports
